/**
 * 컬럼 정렬(alignment) 클래스
 * 컬럼 정의에 align: "center" | "right" 를 주면 셀(값)에만 적용된다.
 * 헤더는 컬럼 공통규칙에 따라 항상 좌측 정렬이다.
 * 미지정 컬럼은 기존 좌측 정렬을 유지한다.
 * @see Ctrl.R 컬럼 메타데이터 및 표시 규칙 정의서
 */
export const getColumnAlignClassName = (column: { align?: string } | undefined): string => {
  switch (column?.align) {
    case "center":
      return "justify-contents-center";
    case "right":
      return "justify-contents-end";
    default:
      return "";
  }
};
